import { ActionCard } from '@dynamo-caffeina-dev/airc-ui-kit'
import { ActionCardProps } from '@/types'
import { dispatchGTMEvent, GTM_EVENT_CATEGORY } from '@/helpers/gtm'

// The `type` field is there, I don't know why TS won't see it
// @ts-ignore
type ActionType = ActionCardProps['action']['type']

interface ActionContent {
  title: string
  body: string
  navigate: ActionType
  url: string
}

export interface ActionClusterProps {
  items: {
    content: ActionContent
  }[]
}

function mapActionToIcon(action: ActionType) {
  switch (action) {
    case 'navigate':
      return 'ArrowTopRight'

    case 'call':
      return 'Phone'

    case 'copy':
      return 'Copy'

    default:
      return undefined
  }
}

const ActionCluster = ({ items }: ActionClusterProps) => {
  const handleClickCapture = (content: ActionContent) => {
    dispatchGTMEvent(GTM_EVENT_CATEGORY.SUPPORT_US, {
      section: `Action: "${content.navigate}"; title: "${content.title}"`,
    })
  }

  return (
    <div className='action-cluster'>
      {items.map(({ content }) => (
        <ActionCard
          key={content.title}
          title={content.title}
          body={content.body}
          action={{
            type: content.navigate,
            // We can let the icon be falsy, it will be handled
            icon: mapActionToIcon(content.navigate)!,
            url: content.url,
          }}
          // Can't bind the event to the internal button,
          // so we use onClickCapture on the wrapper.
          // This will trigger BOTH  with a wrapper click
          // and an internal button click.
          onClickCapture={() => handleClickCapture(content)}
        />
      ))}
    </div>
  )
}

export default ActionCluster
